import { OccupationTypes } from '@axiom/const';
import type { Location } from '@axiom/types';
import {
  positionReservedTypeValues,
  type ProjectNeedsWithLegalSkills,
} from '@axiom/validation';

export const DirectEngagementsFormUtil = {
  findState(locationData?: Location): string | null {
    const addresses = locationData?.locationAddressComponents?.addresses;
    if (!Array.isArray(addresses)) return null;
    for (const address of addresses) {
      if (address.types.includes('administrative_area_level_1')) {
        return address.long_name;
      }
    }
    return null;
  },

  shouldDisplayLegalSupportHoursWarning({
    billingUnitsPerWeek,
    occupationType,
  }: Partial<
    Pick<ProjectNeedsWithLegalSkills, 'billingUnitsPerWeek' | 'occupationType'>
  >) {
    if (billingUnitsPerWeek === undefined) {
      return false;
    }

    return (
      occupationType === OccupationTypes.LEGAL_SUPPORT &&
      billingUnitsPerWeek < 20
    );
  },

  shouldDisplayMinPayStatesWarning({
    billingUnitsPerWeek,
    companyLocation,
    occupationType,
  }: Partial<
    Pick<
      ProjectNeedsWithLegalSkills,
      'billingUnitsPerWeek' | 'companyLocation' | 'occupationType'
    >
  >) {
    const restrictedStatesForMinimumPay = [
      'california',
      'oregon',
      'pennsylvania',
      'illinois',
    ];
    if (!companyLocation) return false;
    const state = DirectEngagementsFormUtil.findState(companyLocation);

    if (billingUnitsPerWeek === undefined) {
      return false;
    }

    return (
      restrictedStatesForMinimumPay.includes(state?.toLowerCase()) &&
      billingUnitsPerWeek < 20 &&
      occupationType === OccupationTypes.lawyer
    );
  },

  shouldDisplayPayAsYouGoBudgetWarning({
    reservedType,
    maxBudgetPerHour,
  }: Partial<
    Pick<ProjectNeedsWithLegalSkills, 'reservedType' | 'maxBudgetPerHour'>
  >) {
    if (reservedType === undefined || maxBudgetPerHour === undefined) {
      return false;
    }

    return (
      reservedType === positionReservedTypeValues['Not Reserved'] &&
      maxBudgetPerHour < 200
    );
  },

  shouldDisplayReservePricingWarning({
    billingUnitsPerWeek,
    reservedType,
  }: Partial<
    Pick<ProjectNeedsWithLegalSkills, 'billingUnitsPerWeek' | 'reservedType'>
  >) {
    if (billingUnitsPerWeek === undefined) {
      return false;
    }

    return (
      reservedType === positionReservedTypeValues.Reserved &&
      billingUnitsPerWeek < 10
    );
  },
};
